import * as XLSX from 'xlsx';
import { GRUPOS_LABELS } from './constantesGastos';

/**
 * Exportación Excel para gastos fijos y entradas mensuales.
 */

/**
 * Exporta gastos fijos a un archivo Excel.
 * @param {Array} gastos - Array de { grupo, nombre, valor }
 * @param {Object} subtotales - Objeto con subtotales por grupo
 * @param {number} totalGeneral - Total general de todos los gastos
 * @param {number} mes - Mes del período
 * @param {number} anio - Año del período
 * @returns {Array} rows - Array de arrays (AOA) usado para generar el sheet
 */
export const exportGastosFijos = (gastos, subtotales, totalGeneral, mes, anio) => {
  const rows = [];

  // Header row
  rows.push(['Centro', 'Categoría', 'Valor']);

  // Data rows - use GRUPOS_LABELS to display the human-readable centro name
  gastos.forEach((item) => {
    const centroLabel = GRUPOS_LABELS[item.grupo] || item.grupo;
    rows.push([centroLabel, item.nombre, item.valor]);
  });

  // Total row
  rows.push(['', 'TOTAL GENERAL', totalGeneral]);

  // Generate Excel file
  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Gastos Fijos');
  XLSX.writeFile(wb, `GastosFijos_${mes}_${anio}.xlsx`);

  return rows;
};

/**
 * Exporta entradas mensuales a un archivo Excel.
 * @param {Array} entradas - Array de { id, descripcion, monto, fecha }
 * @param {number} totalMensual - Total mensual (sum de montos)
 * @param {number} sumaAcumulada - Suma acumulada anual
 * @param {string} centroLabel - Nombre del centro
 * @param {number} mes - Mes del período
 * @param {number} anio - Año del período
 * @returns {Array} rows - Array de arrays (AOA) usado para generar el sheet
 */
export const exportEntradas = (entradas, totalMensual, sumaAcumulada, centroLabel, mes, anio) => {
  const rows = [];

  // Header row
  rows.push(['Fecha', 'Descripción', 'Monto']);

  // Data rows
  entradas.forEach((entrada) => {
    const fechaFormatted = entrada.fecha
      ? new Date(entrada.fecha).toLocaleDateString('es-AR')
      : '';
    rows.push([fechaFormatted, entrada.descripcion, entrada.monto]);
  });

  // Total mensual row
  rows.push(['', 'Total Mensual', totalMensual]);

  // Suma acumulada row
  rows.push(['', 'Suma Acumulada', sumaAcumulada]);

  // Generate Excel file
  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Entradas');
  XLSX.writeFile(wb, `Entradas_${centroLabel}_${mes}_${anio}.xlsx`);

  return rows;
};
